import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import { data } from './local';
import { createStyles, DialogActions, DialogContent, makeStyles, Paper, Popper, styled, Typography } from '@material-ui/core';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { Theme } from '@mui/material/styles';
import { DataGrid, GridColDef, GridEditRowsModel, GridRenderCellParams, GridSortDirection, GridSortModel, GridValueGetterParams } from '@mui/x-data-grid';
import { getNominatorMail, getToken, getUserGraphId } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { Alert, Box, Button, Dialog, DialogContentText, DialogTitle } from '@mui/material';
import { NotificationAlert } from "../components/NotificationAlert";
import { getImpactedNominationsCount, getRegionsMinistryList, getRegionsMinistryMasterData, getRegionsMinistryNominationsCount, UpdateMinistryandRegion } from './services';
import { appInsights } from '../AppInsights';


const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    fontFamily: 'Barlow',
  },
}));


const RegionMinistry: FunctionComponent<any> = () => {
  let history: any = useHistory();

  const [alertType, setAlertType] = useState('');
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState<any>('');
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { VIANominations } = languageData[languageSelected];
  const [regionsMinistryList, setRegionsMinistryList] = useState<any>('');
  const [regionsMinistryMasterDataList, setRegionsMinistryMasterDataList] = useState<any>('');
  const [count, Setcount] = useState(0);
  const [openUpdateRegion, setOpenForUpdateRegion] = React.useState(false);
  const [regiondata, setRegionToUpdate] = React.useState<any>();
  // const [impactedRegionsMinistryList, setImpactedRegionsMinistryList] = useState<any []>();
  const [regionMinistryNominationsCount, setRegionMinistryNominationsCount] = React.useState<any>();

  let impactedList: { id: string; Company: any; City: any; Count: any; }[] = [];
  const [editRowsModel, setEditRowsModel] = React.useState({});

  const handleEditRowsModelChange = React.useCallback((model: GridEditRowsModel) => {
    setEditRowsModel(model);
  }, []);


  //UseEffects

  useEffect(() => {
    setEditRowsModel({});
    RegionsMinistryNominationsCount();
    ImpactedNominationsCount();
    RegionsMinistryMasterData();
  }, [count])


  const RegionsMinistryNominationsCount = () => {

    getRegionsMinistryNominationsCount().then((response: any) => {
      if (response != null) {
        setRegionMinistryNominationsCount(response);

      }
    });
  };

  const ImpactedNominationsCount = () => {

    getImpactedNominationsCount().then((response: any) => {
      if (response != null) {
        for (let key in response) {
          impactedList.push({ id: key, Company: response[key].company, City: response[key].city, Count: response[key].count });
        }
      }
      RegionsMinistryList();

    });
  };

  const RegionsMinistryMasterData = () => {

    getRegionsMinistryMasterData().then((response: any) => {
      if (response != null) {
        let ListOfRegionsMinistry = [];
        for (let key in response) {
          ListOfRegionsMinistry.push({
            id: key, Company: response[key].company, City: response[key].city, Region: response[key].region, Ministry: response[key].ministry_report
          });
        }
        setRegionsMinistryMasterDataList(ListOfRegionsMinistry);
      }

    });
  };

  const RegionsMinistryList = () => {

    getRegionsMinistryList().then((response: any) => {
      if (response != null) {
        let ListOfRegionsMinistry = [];
        for (let key in response) {
          ListOfRegionsMinistry.push({
            id: key, Company: response[key].company, City: response[key].city,
            Count: '0',
            Region: response[key].region, Ministry: response[key].ministry_report
          });

        }
        if (ListOfRegionsMinistry.length > 0) {
          ListOfRegionsMinistry.map(function (RegionsMinistryValue) {
            var result = impactedList.filter(impactedValue => (impactedValue.Company == RegionsMinistryValue.Company && impactedValue.City == RegionsMinistryValue.City));
            if (result.length > 0) {
              RegionsMinistryValue.Count = result[0].Count;
            }
          })
          setRegionsMinistryList(ListOfRegionsMinistry);
        }
      }
    });
  };

  const columns: GridColDef[] = [

    { field: 'id', headerName: 'ID', hide: true },
    { field: 'Company', headerName: 'Company', editable: false, minWidth: 150, flex: 1, renderCell: renderCellExpand },
    { field: 'City', headerName: 'City', editable: false, minWidth: 150, flex: 1, renderCell: renderCellExpand },
    { field: 'Count', headerName: 'Count', minWidth: 150, flex: 0.3, renderCell: renderCellExpand },
    { field: 'Region', headerName: 'Region', editable: true, minWidth: 150, flex: 1 },
    { field: 'Ministry', headerName: 'Ministry', editable: true, minWidth: 150, flex: 1 },
    {
      field: 'actions', type: 'actions', minWidth: 50, flex: 0.5,
      renderCell: (cellvalues: any) => (
        <strong>

          {cellvalues.value}

          <Button
            className={styles.AddAwardeeBttn}
            variant="contained"
            color="primary"
            size="small"
            style={{ marginBottom: '16px' }}
            onClick={() => Update(cellvalues, editRowsModel)}
          > Save  </Button>
        </strong>
      ),

    }

  ]

  const mastercolumns: GridColDef[] = [

    { field: 'id', headerName: 'ID', hide: true },
    { field: 'Company', headerName: 'Company', editable: false, minWidth: 150, flex: 1, renderCell: renderCellExpand },
    { field: 'City', headerName: 'City', editable: false, minWidth: 150, flex: 1, renderCell: renderCellExpand },
    { field: 'Region', headerName: 'Region', editable: true, minWidth: 150, flex: 1 },
    { field: 'Ministry', headerName: 'Ministry', editable: true, minWidth: 150, flex: 1 },
    {
      field: 'actions', type: 'actions', minWidth: 50, flex: 0.5,
      renderCell: (cellvalues: any) => (
        <strong>

          {cellvalues.value}

          <Button
            className={styles.AddAwardeeBttn}
            variant="contained"
            color="primary"
            size="small"
            style={{ marginBottom: '16px' }}
            onClick={() => Update(cellvalues, editRowsModel)}
          > Save  </Button>
        </strong>
      ),
    }
  ]

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  const handleClose = () => {
    Setcount((count: number) => count + 1);
    setOpenForUpdateRegion(false);
    setRegionToUpdate(null);
    setEditRowsModel({});
    Setcount((count: number) => count + 1);
  };

  function Update(value: any, value2: any) {

    if (value.row.id == Object.keys(value2)[0]) {
      const valueSelected: any = Object.values(value2)[0];

      value.row.Region = valueSelected['Region'].value;
      value.row.Ministry_report = valueSelected['Ministry'].value;
      if (value.row.Ministry_report != "" && value.row.Ministry_report != null && value.row.Region != "" && value.row.Region != null) {
        setRegionToUpdate(value.row);
        setOpenForUpdateRegion(true);
      }
      else {
        setAlertType('error');
        setAlertContent('Please enter both Ministry and Region to proceed.!');
        setAlert(true);
        setTimeout(() => { setAlert(false); }, 4000);
      }
    }
  }

  const UpdateMinistrybuttonHandler = async () => {

    setOpenForUpdateRegion(false);

    await UpdateMinistryandRegion(regiondata);
    Setcount((count: number) => count + 1);
    setAlertContent('Updated details successfully.!');
    setAlertType('success');
    setAlert(true);
    appInsights.trackEvent({ name: "UpdatedRegionandMinistry", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
    setTimeout(() => { setAlert(false); }, 3000);
    Setcount((count: number) => count + 1);
    setEditRowsModel({});

  };

  const [sortModel, setSortModel] = React.useState<GridSortModel>([
    {
      field: 'Count',
      sort: 'desc' as GridSortDirection,
    },
  ]);

  const classes = useStyles();


  return (
    <React.Fragment>
      <Container maxWidth={"xl"} >
        <div className={styles.adminPage}>
          {alert && <NotificationAlert state={alert} notificationMessage={alertContent} alertType={alertType} />}
          <h2 className={styles.headerBold}>Update Region and Ministry</h2>
          <h2 className={styles.header}>Total Region/Ministry missing nominations: {regionMinistryNominationsCount}</h2>
          <hr />
          <div style={{ height: '300', width: '100%' }}>
            <Box
              sx={{
                height: '50vh',
                width: 1,
                '& .css-1b74o31-MuiInputBase-root-MuiDataGrid-editInputCell': {
                  bgcolor: (theme) =>
                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 200)',
                },
              }}
            >
              <DataGrid

                columns={columns}
                rows={regionsMinistryList}
                pageSize={5}
                className={classes.root}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick={true}
                sortModel={sortModel}
                onSortModelChange={(model) => setSortModel(model)}
                editRowsModel={editRowsModel}
                editMode="row"
                onEditRowsModelChange={handleEditRowsModelChange}
                rowHeight={40}

              />

            </Box>
          </div>
          <div style={{ height: '300', width: '100%' }}>
            <h2 className={styles.header}>Edit Region/Ministry Master Data</h2>
            <hr />
            <Box
              sx={{
                height: '50vh',
                width: 1,
                '& .css-1b74o31-MuiInputBase-root-MuiDataGrid-editInputCell': {
                  bgcolor: (theme) =>
                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 200)',
                },
              }}
            >
              <DataGrid

                columns={mastercolumns}
                rows={regionsMinistryMasterDataList}
                pageSize={5}
                className={classes.root}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick={true}
                editRowsModel={editRowsModel}
                editMode="row"
                onEditRowsModelChange={handleEditRowsModelChange}
                rowHeight={40}

              />
            </Box>
          </div>
          <br></br>

          <Dialog
            open={openUpdateRegion}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>
              {"Update Row "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to update this row?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={styles.messageBoxEditor} onClick={UpdateMinistrybuttonHandler} autoFocus>
                Yes
              </Button>
              <Button className={styles.messageBoxEditor} onClick={handleClose}>No</Button>

            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </React.Fragment>
  );
}


//Css
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: '2px solid',
      fontFamily: 'Barlow !important',
      backgroundColor: '#FFFFFF',


      '& .MuiDataGrid-cell:hover': {
        color: '#00338e',
      },
      '& .MuiDataGrid-columnHeader': {
        color: '#FFFFFF',
        backgroundColor: '#00338e',
        fontSize: 'calc(5px + 2vmin)',
        '& .MuiCheckbox-root svg path': {
          color: 'white',
        }
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell': {
        fontSize: 'calc(2px + 2vmin)',
        borderRadius: 4,
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
          }`,
      },
      '& .MuiDataGrid-cell--editing': {
        backgroundColor: '#f0f5ff !important',
      }


      //   '& .MuiDataGrid-iconSeparator': {
      //     display: 'none',
      //   },
      //   '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
      //     borderRight: `1px solid ${
      //       theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
      //     }`,
      //   },


    },
  }),
);

interface GridCellExpandProps {
  value: string;
  width: number;
}

function isOverflown(element: Element): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(
  props: GridCellExpandProps,
) {
  const { width, value } = props;
  const wrapper = React.useRef<HTMLDivElement | null>(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current!);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent: KeyboardEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        width: 1,
        height: 1,
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current!.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

function renderCellExpand(params: GridRenderCellParams<string>) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
  );
}

export default RegionMinistry;




